import React from 'react'
import Header from '../../component/Header'
import Footer from '../../component/Footer'
import Diploma from '../Diploma'
import CourseBA from '../CourseBA'

export default function LayoutCourseBA() {
    return (
        <div>
            <Header />
            <CourseBA />
            <Footer />
        </div>
    )
}
